module.exports = __webpack_public_path__ + "img/M-3year-bar.4b6ddc75.png";